export const fontWeights = {
  bold: "625",
  medium: "550",
  regular: "450",
};
